// extracted by mini-css-extract-plugin
module.exports = {"dialog":"styles_dialog__2mF-c","container":"styles_container__39LUh"};